import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-26eadb07"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "total-text"
};
const _hoisted_2 = {
  key: 9
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_hashed_number_value = _resolveComponent("hashed-number-value");
  const _component_percentage_value = _resolveComponent("percentage-value");
  const _component_evolution_value = _resolveComponent("evolution-value");
  const _component_slot_with_evolution_value = _resolveComponent("slot-with-evolution-value");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_number_value = _resolveComponent("number-value");
  const _component_hug_value = _resolveComponent("hug-value");
  const _component_b_td = _resolveComponent("b-td");
  return _openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.fields, field => {
    return _openBlock(), _createBlock(_component_b_td, {
      key: field.key,
      class: _normalizeClass([{
        'b-table-sticky-column': $options.isStickyColumn(field),
        'no-border-right': $options.noBorderRight(field)
      }, field.class])
    }, {
      default: _withCtx(() => [_createVNode(_component_hug_value, {
        class: "total-element",
        styles: {
          justifyContent: $options.getJustify(field),
          padding: '8px'
        },
        loading: $props.loading
      }, {
        default: _withCtx(() => [$options.isTotalColumn(field) ? (_openBlock(), _createElementBlock("span", _hoisted_1, "TOTAL")) : _createCommentVNode("", true), field.key === 'seller_market_share_rank' ? (_openBlock(), _createElementBlock(_Fragment, {
          key: 1
        }, [_ctx.groupBy !== 'competitor' ? (_openBlock(), _createBlock(_component_hashed_number_value, {
          key: 0,
          value: $props.total?.seller_marketshare_rank,
          hashColor: "unset",
          style: {
            gap: '0px',
            width: '4ch'
          }
        }, null, 8, ["value"])) : _createCommentVNode("", true)], 64)) : _createCommentVNode("", true), field.key === 'seller_market_share' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 2,
          gap: 4
        }, {
          evolution: _withCtx(() => [$props.total?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`seller_marketshare_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              pp: "",
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_ctx.groupBy === 'competitor' ? (_openBlock(), _createBlock(_component_percentage_value, {
            key: 0,
            value: 1,
            type: "market_insights_evol_table",
            tight: "",
            align: "left"
          })) : (_openBlock(), _createBlock(_component_percentage_value, {
            key: 1,
            value: $props.total.seller_marketshare,
            precision: $props.total.seller_marketshare >= 0.01 && $props.total.seller_marketshare < 0.05 ? 1 : 0,
            type: "market_insights_evol_table",
            tight: "",
            align: "left"
          }, null, 8, ["value", "precision"]))]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'category_revenue_share' ? (_openBlock(), _createBlock(_component_percentage_value, {
          key: 3,
          value: $props.total.total_revenue_share,
          precision: "0"
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'seller_share_of_units_sold' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 4,
          gap: 4
        }, {
          evolution: _withCtx(() => [$props.total?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`seller_share_of_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              pp: "",
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_ctx.groupBy === 'competitor' ? (_openBlock(), _createBlock(_component_percentage_value, {
            key: 0,
            value: 1,
            type: "market_insights_evol_table",
            align: "left"
          })) : (_openBlock(), _createBlock(_component_percentage_value, {
            key: 1,
            value: $props.total.seller_share_of_units_sold,
            precision: $props.total.seller_share_of_units_sold >= 0.01 && $props.total.seller_share_of_units_sold < 0.05 ? 1 : 0,
            type: "market_insights_evol_table",
            align: "left"
          }, null, 8, ["value", "precision"]))]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'avg_seller_price' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 5,
          value: $props.total.ag_seller_price,
          precision: "1"
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'market_size' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 6,
          gap: 4
        }, {
          evolution: _withCtx(() => [$props.total?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`market_size_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_currency_value, {
            value: $props.total.market_size,
            allowPrecisionModification: false
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'market_units_sold' ? (_openBlock(), _createBlock(_component_slot_with_evolution_value, {
          key: 7,
          gap: 4
        }, {
          evolution: _withCtx(() => [$props.total?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`] !== null ? (_openBlock(), _createBlock(_component_evolution_value, {
            key: 0,
            value: $props.total?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`]
          }, {
            default: _withCtx(({
              color
            }) => [_createVNode(_component_percentage_value, {
              value: $props.total?.[`market_units_sold_evol${$data.evolCategory[_ctx.periodCategory]}`],
              color: color,
              showSign: ""
            }, null, 8, ["value", "color"])]),
            _: 1
          }, 8, ["value"])) : _createCommentVNode("", true)]),
          default: _withCtx(() => [_createVNode(_component_number_value, {
            value: $props.total.market_units_sold,
            tight: "",
            align: "left"
          }, null, 8, ["value"])]),
          _: 1
        })) : _createCommentVNode("", true), field.key === 'avg_market_price' ? (_openBlock(), _createBlock(_component_currency_value, {
          key: 8,
          value: $props.total.avg_market_price,
          precision: "1"
        }, null, 8, ["value"])) : _createCommentVNode("", true), field.key === 'market_price_range' ? (_openBlock(), _createElementBlock("div", _hoisted_2)) : _createCommentVNode("", true)]),
        _: 2
      }, 1032, ["styles", "loading"])]),
      _: 2
    }, 1032, ["class"]);
  }), 128);
}